import { render, staticRenderFns } from "./actions_column_fields.vue?vue&type=template&id=c741654a"
import script from "./actions_column_fields.vue?vue&type=script&lang=js"
export * from "./actions_column_fields.vue?vue&type=script&lang=js"
import style0 from "./actions_column_fields.vue?vue&type=style&index=0&id=c741654a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports